export default Object.freeze({
    NONE: 'none',
    TEAM: 'team',
    STAFET: 'stafet',
    DELTAGER: 'participant',
})
